import React from "react";
import { useNavigate } from "@tanstack/react-router";
import { ListVideoIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { EpisodeDesktopControlsSkeleton } from "./components/EpisodeDesktopControls";
import { EpisodeBreadcrumbSkeleton } from "./components/EpisodeBreadcrumb";
import { Separator } from "@/components/ui/separator";
import VideoVerticalPlayer from "@/components/VideoVerticalPlayer";
import { cn } from "@/lib/utils";

const EpisodesPlayerSkeleton: React.FC<React.ComponentProps<"div">> = ({
  className,
  ...props
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div
      className={cn(
        "grid h-full min-h-0 w-full gap-8 lg:m-auto lg:max-w-5xl lg:grid-rows-[auto_1fr] lg:px-4",
        className,
      )}
      {...props}
    >
      <div className="hidden flex-col gap-4 lg:flex">
        <EpisodeBreadcrumbSkeleton />
        <Separator />
      </div>
      <div className="relative h-full min-h-0 w-full gap-10 lg:m-auto lg:grid lg:min-h-0 lg:grid-cols-[1fr_375px] lg:justify-center">
        <VideoVerticalPlayer.Skeleton
          className="h-full grow lg:col-span-1 lg:aspect-9/16 lg:h-[calc(100%-64px)] lg:max-h-[1024px] lg:max-w-full lg:rounded-lg"
          onClose={() => navigate({ to: "/" })}
          sideControls={[
            { label: t("player_episodes_control_label"), icon: ListVideoIcon },
            { label: t("player_episodes_control_label"), icon: ListVideoIcon },
            { label: t("player_episodes_control_label"), icon: ListVideoIcon },
          ]}
        />
        <EpisodeDesktopControlsSkeleton />
      </div>
    </div>
  );
};

export default EpisodesPlayerSkeleton;
